import * as React from 'react'
import { BPMChart } from '../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../api'
import { ArgumentAxis, Legend, Series, Label } from 'devextreme-react/chart'
import { getColor } from '../../../utils/corlor'

export const TopStateChart: React.FunctionComponent<{ album: string }> = ({ album }) => {
    const color = getColor(2)
    return (
        <BPMChart title='Top US States' subTitle={'By Downloads'} type='bar'
            allowedTypes={['spline', 'bar', 'doughnut', 'pie']}
            additionalParams={{ album }}
            onRequestLoad={(options, signal) => {
                return (BPMAnalyticsAPI.get<any>('album/us-states', options, signal)).then((data) => {
                    return data.sort((item1, item2) => {
                        return item1.count - item2.count
                    }).reverse().reduce((prev, current) => {
                        if (prev.length < 10) {
                            prev.push(current)
                        } else {
                            if (prev.length == 10) {
                                let other = current
                                other.state = 'Other'
                                prev.push(current)
                            } else {
                                let other = prev[10]
                                other.count += current.count
                            }
                        }
                        return prev
                    }, []).reverse()
                })
            }} horizontal>
            <Series
                valueField="count"
                argumentField="state"
                color={color}>
                <Label backgroundColor={color} customizeText={(arg: any) => {
                    return `${arg.valueText} (${arg.percentText})`
                }}>
                </Label>
            </Series>
            <ArgumentAxis aggregateByCategory={true}>
            </ArgumentAxis>
            <Legend visible={false} />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Album/charts/TopStateChart.tsx